import { IconActionSearch16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './SearchIcon.css';
import { FC } from 'react';

export const RegionalDistrictsSearchIcon: FC = () => {
  return (
    <div className={styles['search-icon']}>
      <IconActionSearch16 color="icon-main-default" />
    </div>
  );
};
